import Loader from "@/components/loader/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import * as firebase from "firebase";
import {getRegionName} from "@/utils/functionsRegion";

export default {
  name: "maintenanceCreateRequest",
  components: {
    Loader,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      loading: {
        page: true,
        create: false
      },
      newMaintenanceRequest: {
        name: "",
        description: "",
        residentName: "",
        roomName: "",
        location: "",
        type: "QR Code",
        status: "new",
        icon: "qrcode"
      },
      maintenanceTypes: []
    }
  },
  async created() {
    this.loading.page = false;
  },
  methods: {
    async submit() {
      if(!this.$route.query.facilityId) {
        this.$toast.open({
          type: "error",
          message: this.$t("Maintenance.CreateMaintenanceRequest.ScanQRCodeOneMoreTime")
        });
        return;
      }

      const isObjectValid = this.validateObject(this.newMaintenanceRequest);
      if(!isObjectValid) {
        this.$toast.open({
          type: "error",
          message: "The form contains invalid characters"
        });

        return;
      }

      try {
        this.loading.create = true;
        this.newMaintenanceRequest.facilityId = this.$route.query.facilityId;

        await firebase
          .app()
          .functions(getRegionName())
          .httpsCallable("maintenance-createMaintenanceRequestByQRCode")({
            request: this.newMaintenanceRequest
          })
          .then(async () => {
            this.$toast.open({
              type: "success",
              message: "Maintenance request has been successfully created"
            });
            this.clearForm()
          }).catch((err) => {
            console.log(err)
            this.$toast.open({
              type: "error",
              message: this.$t("GeneralTranslations.UnhandledError")
            })
          }).finally(() => {
            this.loading.create = false;
          })
      } catch (err) {
        console.log(err)
        this.$toast.open({
          type: "error",
          message: this.$t("GeneralTranslations.UnhandledError")
        })
      }
    },
    validateField(input) {
      const regex = /^[a-zA-Zа-яА-ЯёЁіІїЇєЄ0-9\s.,'"\-!@#$%^&*()_+=[\]{}:;?]*$/u;
      return regex.test(input);
    },
    validateObject(obj: any) {
      for (const key in obj) {
        if (!this.validateField(obj[key])) {
          this.$toast.open({
            type: "error",
            message: `Field "${key}" is not valid.`
          })
          return false;
        }
      }
      return true;
    },
    clearForm() {
      this.newMaintenanceRequest.name = "";
      this.newMaintenanceRequest.description = "";
      this.newMaintenanceRequest.residentName = "";
      this.newMaintenanceRequest.roomName = "";
      this.newMaintenanceRequest.location = "";

      setTimeout(() => {
        location.reload();
      }, 2000)
    }
  }
}